import { createFileRoute, Link } from "@tanstack/react-router";
import { useAdminStats } from "@/lib/query-hooks";

export const Route = createFileRoute("/admin/")({
  component: AdminDashboard,
});

function AdminDashboard() {
  const { data, isLoading, isError } = useAdminStats();
  const stats = data ?? {
    exams: 0,
    subjects: 0,
    directories: 0,
    files: 0,
    reportsOpen: 0,
    storageBytes: 0,
  };

  const cards = [
    { label: "Exams", value: stats.exams },
    { label: "Subjects", value: stats.subjects },
    { label: "Directories", value: stats.directories },
    { label: "Files", value: stats.files },
    { label: "Open reports", value: stats.reportsOpen },
    { label: "Storage (MB)", value: Math.round((stats.storageBytes || 0) / 1e6) },
  ];

  return (
    <div>
      <div className="label-card">Dashboard</div>
      <h1 className="mt-1 font-display text-3xl font-semibold">Overview</h1>
      {isError ? (
        <div className="mt-3 text-xs text-warning">
          Backend not reachable — showing zeros.
        </div>
      ) : null}

      <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} className="card-ledger p-5">
            <div className="label-card">{c.label}</div>
            <div className="mt-2 font-display text-3xl font-semibold">
              {isLoading ? "—" : c.value}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        <Link
          to="/admin/exams"
          className="card-ledger p-6 hover:border-paprika transition"
        >
          <div className="label-card">Content</div>
          <div className="mt-2 font-display text-xl font-semibold">
            Manage exams, subjects, and folders →
          </div>
          <p className="mt-2 text-sm text-ink-soft">
            Add or reorder exams, edit subject metadata, and shape the folder
            tree for each module.
          </p>
        </Link>
        <Link
          to="/admin/reports"
          className="card-ledger p-6 hover:border-paprika transition"
        >
          <div className="label-card">Moderation</div>
          <div className="mt-2 font-display text-xl font-semibold">
            Review reported files →
          </div>
          <p className="mt-2 text-sm text-ink-soft">
            Broken links, wrong-file uploads, incorrect year — triage here.
          </p>
        </Link>
      </div>
    </div>
  );
}
